export default __webpack_public_path__ + "static/media/warning.76e4caaa.svg";